module.exports = __webpack_public_path__ + "build/img/hands-with-keyboard.7cc7480e.png";